import React from "react";
import Card from "components/card";
import { Trophy } from "lucide-react";
import AccessButton from "components/button/accessbutton";
import { CATEGORY_CONFIG } from "variables/constants";
import AwardCardCompact from "./AwardCardCompact";

const MyAwards = () => {

    const awards = ["innovation-trailblazer", "peak-performer", "ceo-award"];

    return (
        <Card classNme="text-card-foreground flex flex-col gap-6 rounded-xl border border-purple-200 bg-gradient-to-br from-white to-purple-50/30">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6 pb-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="p-2 rounded-full bg-gradient-to-br from-amber-400 to-orange-500">
                            <Trophy className="w-5 h-5 text-white" />
                        </div> 
                        <div>
                            <h4 className="text-[16px]">
                                My Awards & Recognition
                            </h4>
                            <p className="text-slate-700 text-[11px]">
                                Recent achievements and badges
                            </p>
                        </div>
                    </div>
                    <AccessButton 
                        label="View All Awards"
                        to="/console/employee-awards"
                        btnClass="btn-awards"
                    />
                </div>
            </div>
            <div className="px-6 pb-6 pt-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {awards.map((key) => {
                        const category = CATEGORY_CONFIG[key];
                        return (
                            <AwardCardCompact
                                key={category.id}
                                title={category.title}
                                date="Sept 2025"
                                icon={category.icon}
                                category={category.colorClass}
                                popoverContent={category.award}
                            />
                        );
                    })}
                </div>
            </div>
        </Card>
    )
};
export default MyAwards;